import { Box } from '@mui/material';
import React from 'react';

import { MobileCaption } from '../Typography';

export interface FilterGroupProps {
  label: string;
  children: React.ReactNode;
}

const FilterGroup: React.FC<FilterGroupProps> = ({ label, children }) => (
  <Box sx={{ mb: 2 }}>
    <MobileCaption
      component="span"
      sx={{
        display: 'block',
        color: 'text.secondary',
        fontSize: '0.875rem',
        fontWeight: 500,
        mb: 1,
      }}
    >
      {label}
    </MobileCaption>
    {children}
  </Box>
);

export default FilterGroup;
